import OrganizationFileUpdate from "./OrganizationFileUpdate";
import OrganizationFileUpdateError from "./OrganizationFileUpdateError";

export default class OrganizationFileUpdateHeader {
  Id: string = "";
  Deleted: boolean = false;
  Items: OrganizationFileUpdate[] = [];
  Errors: OrganizationFileUpdateError[] = [];
}
